// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 3: JESUCRISTO
// ============================================================================
// Niveles 27-39 (13 niveles, 39 preguntas)

export const chapter3Translations = {
  name: 'Jesucristo',
  description: 'El Verbo se hizo carne... Conocer a Cristo es la vida eterna',
  
  spiritualWisdom: {
    principle: 'Conocer a Jesucristo es la vida eterna',
    scripture: 'Y esta es la vida eterna: que te conozcan a ti, el único Dios verdadero, y a Jesucristo, a quien has enviado (Juan 17:3)',
    application: 'Cada aspecto de la vida de Jesús revela a Dios y nutre nuestra alma para la eternidad'
  },
  
  levels: {
    27: {
      name: 'La Anunciación',
      challenge: 'El ángel Gabriel fue enviado por Dios a una ciudad de Galilea...',
      easy: {
        question: '¿Qué ángel anunció a María que llevaría a Jesús?',
        options: ['Miguel', 'Gabriel', 'Rafael', 'Uriel'],
        hint: 'El ángel mensajero de Dios',
        funFact: '👼 Gabriel significa Fuerza de Dios - ¡el ángel de los grandes anuncios!'
      },
      medium: {
        question: '¿Cuál fue la primera reacción de María ante este anuncio?',
        options: [
          'Alegría inmediata',
          'Incredulidad total',
          'Turbación y la pregunta ¿Cómo será esto?',
          'Miedo'
        ],
        hint: 'Una pregunta práctica y legítima',
        funFact: '🤔 ¡María hace una pregunta lógica pero mantiene un corazón abierto a Dios!'
      },
      hard: {
        question: '¿Qué nos enseña la sumisión de María a la voluntad divina?',
        options: [
          'La pasividad ante las pruebas',
          'La fe que confía aun sin entender todo',
          'La obediencia ciega',
          'La resignación'
        ],
        hint: 'Se trata de confiar en Dios incluso en lo desconocido',
        funFact: '🙏 Hágase en mí según tu palabra - ¡modelo de fe confiada!'
      }
    },
    
    28: {
      name: 'La Natividad',
      challenge: 'Dio a luz a su hijo primogénito, lo envolvió en pañales y lo acostó en un pesebre...',
      easy: {
        question: '¿En qué ciudad nació Jesús?',
        options: ['Nazaret', 'Jerusalén', 'Belén', 'Cafarnaúm'],
        hint: 'La ciudad de David',
        funFact: '🏘️ Belén significa Casa del pan - ¡Jesús, pan de vida!'
      },
      medium: {
        question: '¿Quiénes fueron los primeros en recibir el anuncio del nacimiento?',
        options: [
          'Los reyes magos',
          'Los pastores en los campos',
          'Los sacerdotes del Templo',
          'La familia de María'
        ],
        hint: 'Gente sencilla que cuidaba sus rebaños',
        funFact: '🐑 ¡Dios anuncia primero a los humildes pastores - el Evangelio para todos!'
      },
      hard: {
        question: '¿Qué simboliza Jesús nacido en un pesebre?',
        options: [
          'La pobreza de sus padres',
          'La humildad de Dios que se rebaja hasta nosotros',
          'La falta de lugar',
          'La simplicidad rural'
        ],
        hint: 'Se trata de la encarnación divina en la humildad',
        funFact: '👶 ¡El Creador del universo nace en un establo - amor infinito!'
      }
    },

    29: {
      name: 'Los Magos de Oriente',
      challenge: 'Unos magos de Oriente llegaron a Jerusalén y preguntaron...',
      easy: {
        question: '¿Qué guió a los magos hacia Jesús?',
        options: ['Un ángel', 'Una estrella', 'Una visión', 'Un mapa'],
        hint: 'Un astro en el cielo',
        funFact: '⭐ ¡La estrella representa que Jesús es la luz de las naciones!'
      },
      medium: {
        question: '¿Qué regalos ofrecieron los magos?',
        options: [
          'Comida',
          'Oro, incienso y mirra',
          'Ropas preciosas',
          'Juguetes'
        ],
        hint: 'Tres presentes simbólicos y preciosos',
        funFact: '🎁 Oro (realeza), incienso (divinidad), mirra (sacrificio) - ¡toda la misión de Jesús!'
      },
      hard: {
        question: '¿Qué representan estos magos paganos en el plan de Dios?',
        options: [
          'La superioridad de otras religiones',
          'La universalidad de la salvación ofrecida a todos los pueblos',
          'La riqueza material',
          'La ciencia antigua'
        ],
        hint: 'Se trata de la apertura de la salvación a todas las naciones',
        funFact: '🌍 ¡Los magos prefiguran el Evangelio que alcanzará al mundo entero!'
      }
    },

    30: {
      name: 'El Bautismo de Jesús',
      challenge: 'Apenas fue bautizado Jesús, subió del agua...',
      easy: {
        question: '¿Quién bautizó a Jesús?',
        options: ['Pedro', 'Juan el Bautista', 'Andrés', 'Santiago'],
        hint: 'El precursor de Jesús',
        funFact: '🌊 ¡Juan el Bautista se consideraba indigno de desatar las sandalias de Jesús!'
      },
      medium: {
        question: '¿Qué descendió sobre Jesús en su bautismo?',
        options: [
          'Una luz',
          'Una paloma (el Espíritu Santo)',
          'Un ángel',
          'Solo una voz'
        ],
        hint: 'El ave símbolo de paz',
        funFact: '🕊️ ¡La paloma revela la unción divina para comenzar el ministerio!'
      },
      hard: {
        question: '¿Por qué Jesús, sin pecado, se hizo bautizar?',
        options: [
          'Para dar el ejemplo',
          'Para cumplir toda justicia e identificarse con nosotros',
          'Por obligación religiosa',
          'Para recibir el perdón'
        ],
        hint: 'Se trata de solidaridad con la humanidad pecadora',
        funFact: '❤️ ¡Jesús se identifica totalmente con nosotros para salvarnos mejor!'
      }
    },

    31: {
      name: 'La Tentación en el Desierto',
      challenge: 'Jesús fue llevado por el Espíritu al desierto para ser tentado por el diablo...',
      easy: {
        question: '¿Cuánto tiempo ayunó Jesús en el desierto?',
        options: ['30 días', '40 días', '50 días', '60 días'],
        hint: 'El número bíblico de la prueba',
        funFact: '🏜️ ¡Como Moisés y Elías, 40 días de preparación espiritual intensa!'
      },
      medium: {
        question: '¿Cómo rechazó Jesús cada tentación?',
        options: [
          'Por su propia fuerza',
          'Citando las Escrituras',
          'Ignorando a Satanás',
          'Orando solamente'
        ],
        hint: 'El arma espiritual por excelencia',
        funFact: '📖 ¡Escrito está... - la Palabra de Dios, espada del Espíritu!'
      },
      hard: {
        question: '¿Qué nos enseña la tentación de Jesús sobre nuestros combates?',
        options: [
          'Las tentaciones son pecado',
          'La tentación puede ser vencida por la Palabra y la fe',
          'Hay que huir de todo desierto',
          'Solo Jesús puede resistir'
        ],
        hint: 'Se trata de nuestra estrategia frente a las tentaciones',
        funFact: '⚔️ ¡Jesús nos muestra cómo vencer: Palabra de Dios + fe activa!'
      }
    },

    32: {
      name: 'Los Primeros Discípulos',
      challenge: 'Jesús les dijo: Seguidme y os haré pescadores de hombres...',
      easy: {
        question: '¿Cuál era el oficio de Pedro y Andrés?',
        options: ['Pastores', 'Pescadores', 'Carpinteros', 'Recaudadores de impuestos'],
        hint: 'Un oficio del lago de Galilea',
        funFact: '🎣 ¡Jesús transforma a los pescadores de peces en pescadores de almas!'
      },
      medium: {
        question: '¿Cómo reaccionaron los primeros discípulos al llamado?',
        options: [
          'Dudaron mucho tiempo',
          'Pidieron pruebas',
          'Lo dejaron todo y lo siguieron de inmediato',
          'Negociaron'
        ],
        hint: 'Una respuesta inmediata y total',
        funFact: '🚶 ¡La autoridad de Jesús era tan evidente que obedecieron instantáneamente!'
      },
      hard: {
        question: '¿Qué significa seguir a Jesús en nuestra época?',
        options: [
          'Abandonar el trabajo',
          'Vivir según sus enseñanzas y su voluntad',
          'Unirse a una comunidad aislada',
          'Hacer proselitismo solamente'
        ],
        hint: 'Se trata de una transformación de vida y de prioridades',
        funFact: '✨ ¡Seguir a Jesús transforma nuestros corazones, elecciones, destino!'
      }
    },

    33: {
      name: 'El Sermón del Monte',
      challenge: 'Bienaventurados los pobres en espíritu, porque de ellos es el reino de los cielos...',
      easy: {
        question: '¿Cuál es la primera bienaventuranza en el Sermón del Monte?',
        options: [
          'Bienaventurados los limpios de corazón',
          'Bienaventurados los pobres en espíritu',
          'Bienaventurados los mansos',
          'Bienaventurados los pacificadores'
        ],
        hint: 'Se refiere a la humildad espiritual',
        funFact: '😊 Los pobres en espíritu conocen su necesidad de Dios - ¡puerta al reino!'
      },
      medium: {
        question: '¿Qué dijo Jesús sobre los pacificadores?',
        options: [
          'Serán afortunados',
          'Serán llamados hijos de Dios',
          'Serán amados',
          'Serán fuertes'
        ],
        hint: 'Una identidad divina especial',
        funFact: '👑 ¡Los pacificadores se parecen a Dios - testimonio vivo de su naturaleza!'
      },
      hard: {
        question: '¿Cómo invierten las bienaventuranzas los valores del mundo?',
        options: [
          'Condenando la riqueza',
          'Aislando a los creyentes',
          'Proclamando bendición sobre quienes el mundo desprecia',
          'Aboliendo las leyes'
        ],
        hint: 'Se trata de valores divinos opuestos a los valores mundanos',
        funFact: '🔄 ¡Las bienaventuranzas transforman nuestra visión de la felicidad y el éxito!'
      }
    },

    34: {
      name: 'Las Parábolas del Reino',
      challenge: 'Les enseñaba muchas cosas por parábolas...',
      easy: {
        question: 'En la parábola del sembrador, ¿qué representa la semilla?',
        options: [
          'El dinero',
          'La Palabra de Dios',
          'Las buenas obras',
          'El amor'
        ],
        hint: 'Lo que Jesús anuncia y enseña',
        funFact: '🌱 ¡La Palabra de Dios germina y crece en nuestros corazones!'
      },
      medium: {
        question: 'En la parábola del grano de mostaza, ¿qué simboliza esta pequeña semilla?',
        options: [
          'La debilidad humana',
          'El Reino que comienza pequeño pero se hace grande',
          'La importancia de los detalles',
          'La naturaleza'
        ],
        hint: 'Algo que crece de manera espectacular',
        funFact: '🌳 ¡De la semilla más pequeña nace un gran árbol - poder del Reino!'
      },
      hard: {
        question: '¿Por qué enseñaba Jesús en parábolas?',
        options: [
          'Para complicar su mensaje',
          'Para revelar verdades espirituales a través de imágenes familiares',
          'Por falta de tiempo',
          'Para probar la inteligencia'
        ],
        hint: 'Se trata de hacer accesibles los misterios del Reino',
        funFact: '💡 ¡Las parábolas revelan a los corazones abiertos y ocultan a los cerrados!'
      }
    },

    35: {
      name: 'Los Milagros de Jesús',
      challenge: 'Calmó el viento y dijo al mar: ¡Calla! ¡Enmudece!...',
      easy: {
        question: '¿Con cuántos panes alimentó Jesús a 5000 hombres?',
        options: ['3 panes', '5 panes', '7 panes', '12 panes'],
        hint: 'El mismo número que los peces',
        funFact: '🍞 ¡5 panes y 2 peces se convierten en un festín - generosidad divina!'
      },
      medium: {
        question: '¿Qué dijeron los discípulos cuando Jesús calmó la tormenta?',
        options: [
          'Es un mago',
          '¿Quién es éste a quien obedecen el viento y el mar?',
          'Es normal',
          'Debemos irnos de aquí'
        ],
        hint: 'Una pregunta sobre la identidad de Jesús',
        funFact: '⛈️ ¡Hasta los elementos reconocen a su Creador y Maestro!'
      },
      hard: {
        question: '¿Cuál es el propósito principal de los milagros de Jesús?',
        options: [
          'Impresionar a las multitudes',
          'Revelar su divinidad y manifestar el amor de Dios',
          'Ganar influencia',
          'Ayudar solo materialmente'
        ],
        hint: 'Se trata de revelación divina y compasión',
        funFact: '❤️ ¡Cada milagro revela el corazón de Dios: amor, compasión, poder!'
      }
    },

    36: {
      name: 'La Transfiguración',
      challenge: 'Fue transfigurado delante de ellos; su rostro resplandeció como el sol...',
      easy: {
        question: '¿Qué discípulos vieron a Jesús transfigurado?',
        options: [
          'Los doce',
          'Pedro, Santiago y Juan',
          'Solo Pedro y Juan',
          'Las mujeres que lo seguían'
        ],
        hint: 'El círculo íntimo de los tres',
        funFact: '⛰️ ¡Pedro, Santiago y Juan: testigos privilegiados de la gloria divina!'
      },
      medium: {
        question: '¿Qué personajes del Antiguo Testamento aparecieron?',
        options: [
          'Abraham e Isaac',
          'David y Salomón',
          'Moisés y Elías',
          'Adán y Noé'
        ],
        hint: 'El representante de la Ley y el de los Profetas',
        funFact: '📜 ¡Moisés (Ley) y Elías (Profetas) dan testimonio de Jesús!'
      },
      hard: {
        question: '¿Qué revela esta transfiguración sobre la naturaleza de Jesús?',
        options: [
          'Es un gran profeta',
          'Su divinidad oculta se manifiesta temporalmente',
          'Domina la luz',
          'Puede cambiar de apariencia'
        ],
        hint: 'Se trata de la revelación de su naturaleza divina',
        funFact: '✨ ¡La gloria divina de Jesús resplandece - anticipo de su resurrección!'
      }
    },

    37: {
      name: 'La Entrada Triunfal',
      challenge: '¡Hosanna al Hijo de David! ¡Bendito el que viene en el nombre del Señor!...',
      easy: {
        question: '¿Sobre qué animal entró Jesús en Jerusalén?',
        options: ['Un caballo', 'Un burro', 'Un camello', 'A pie'],
        hint: 'Un animal símbolo de humildad y paz',
        funFact: '🐴 ¡El burro simboliza al Rey humilde que viene en paz, no en guerra!'
      },
      medium: {
        question: '¿Qué gritaba la multitud aclamando a Jesús?',
        options: [
          '¡Viva el Rey!',
          '¡Hosanna! ¡Bendito el que viene en el nombre del Señor!',
          '¡Gloria a Dios!',
          '¡Libertad!'
        ],
        hint: 'Un grito de alegría y bendición',
        funFact: '🌿 ¡"Hosanna" significa "Salva ahora" - llamado a la salvación divina!'
      },
      hard: {
        question: '¿Por qué esta entrada es "triunfal" pero trágica?',
        options: [
          'Había poca gente',
          'La multitud que lo aclama lo rechazará en 5 días',
          'Las autoridades estaban ausentes',
          'Estaba lloviendo'
        ],
        hint: 'Se trata de la inconstancia del corazón humano',
        funFact: '💔 ¡La misma multitud gritará "¡Crucifícalo!" pocos días después!'
      }
    },

    38: {
      name: 'La Última Cena',
      challenge: 'Tomad y comed, esto es mi cuerpo que es dado por vosotros...',
      easy: {
        question: '¿Qué hizo Jesús con los pies de sus discípulos?',
        options: [
          'Los bendijo',
          'Los lavó',
          'Los perfumó',
          'Los besó'
        ],
        hint: 'Un gesto de humildad y servicio',
        funFact: '🦶 ¡El Maestro se hace siervo - revolución de amor y humildad!'
      },
      medium: {
        question: '¿Qué instituyó Jesús en esta cena?',
        options: [
          'El bautismo',
          'La comunión (Santa Cena)',
          'El Padre Nuestro',
          'El ayuno'
        ],
        hint: 'Un sacramento con pan y vino',
        funFact: '🍞🍷 ¡Pan y vino se vuelven símbolos eternos de sacrificio y amor!'
      },
      hard: {
        question: '¿Qué significa "Haced esto en memoria de mí"?',
        options: [
          'Repetid esta cena',
          'Celebrad mi muerte y resurrección hasta mi regreso',
          'Recordad mis palabras',
          'Amaos los unos a los otros'
        ],
        hint: 'Se trata de una conmemoración viva y profética',
        funFact: '⏳ ¡Cada comunión anuncia la muerte del Señor hasta su venida!'
      }
    },

    39: {
      name: 'Getsemaní',
      challenge: 'Padre mío, si es posible, pase de mí esta copa...',
      easy: {
        question: '¿Dónde oró Jesús antes de su arresto?',
        options: [
          'En el Templo',
          'En el huerto de Getsemaní',
          'En el Monte de los Olivos',
          'En casa de sus amigos'
        ],
        hint: 'Un huerto de olivos',
        funFact: '🫒 ¡Getsemaní significa "prensa de aceite" - lugar de presión intensa!'
      },
      medium: {
        question: '¿Qué hicieron los discípulos mientras Jesús oraba?',
        options: [
          'Oraron con él',
          'Se durmieron',
          'Montaron guardia',
          'Se fueron'
        ],
        hint: 'No pudieron velar una hora',
        funFact: '😴 ¡El espíritu está dispuesto pero la carne es débil - debilidad humana!'
      },
      hard: {
        question: '¿Qué revela la agonía de Jesús sobre su naturaleza?',
        options: [
          'Era solo hombre',
          'Era plenamente hombre Y plenamente Dios',
          'Dudaba de su misión',
          'Era débil'
        ],
        hint: 'Se trata del misterio de la encarnación',
        funFact: '✝️ ¡Jesús asume plenamente la angustia humana permaneciendo fiel a Dios!'
      }
    }
  }
};

export default chapter3Translations;
